import {React, useState} from "react";
import {useNavigate} from "react-router-dom";
import CustomButton from "../Common/Button";
import {SubmitAnswers} from "../../utils/axios/questionAPI";
import moment from "moment";
import {GetUserInfo} from "../../utils/helper";

const modalStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "white",
  padding: "20px",
  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.5)",
  width: "80%",
  maxHeight: "90vh",
  overflowY: "auto",
  borderRadius: "10px",
};

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thStyle = {
  border: "1px solid #000",
  padding: "8px",
  textAlign: "left",
};

const tdStyle = {
  border: "1px solid #000",
  padding: "8px",
  textAlign: "left",
};

function ReviewPage({isOpen, onClose, questions, selectedAnswers}) {
  const navigate = useNavigate();
  const [userInfo] = useState(GetUserInfo());
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const submitExam = async () => {
    try {
      setIsSubmitting(true);

      // Validate ExamId
      const examIdStr = sessionStorage.getItem("ExamId");
      if (!examIdStr) {
        alert("Exam session not found. Please restart the exam.");
        navigate("/login");
        return;
      }
      const examId = parseInt(examIdStr);

      // Validate token
      const token = sessionStorage.getItem("token");
      if (!token) {
        alert("Your session has expired. Please login again.");
        navigate("/login");
        return;
      }

      if (!questions || questions.length === 0) {
        alert("Cannot submit an empty exam. Please reload your questions.");
        return;
      }

      // Prepare payload
      const questionId = questions.map((q) => q.QuestionId);
      const optionId = selectedAnswers.map((item) => item?.OptionId ?? 0);
      const userId = userInfo?.UserId || userInfo?.Id || userInfo?.[0]?.UserId || 0;

      const examPayload = {
        ExamId: examId,
        QuestionId: questionId,
        OptionId: optionId,
        EndTime: moment().format("YYYY-MM-DD HH:mm:ss"),
        CreatedBy: userId,
      };

      console.log("Submitting payload:", examPayload);

      const response = await SubmitAnswers(examPayload);

      console.log("submitExamResponse:", response);

      if (response.success) {
        // Cleanup session
        sessionStorage.removeItem("userInfo");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("ExamId");
        sessionStorage.removeItem("ExamQuestions");
        sessionStorage.removeItem("SelectedAnswers");
        sessionStorage.removeItem("ExamStartTime");
        localStorage.removeItem("startTime");
        sessionStorage.setItem("isSubmitting", "true");

        if (document.fullscreenElement) {
          document.exitFullscreen().catch(() => {});
        }
        navigate("/thankyou");
      } else {
        const msg =
          response.status === 498
            ? "Your session has expired. Please login again."
            : response.message || "Failed to submit exam.";

        alert(msg);

        if (response.status === 498) {
          navigate("/login");
        }
      }
    } catch (err) {
      console.error("Submit Exam Error:", err);
      alert("Something went wrong while submitting the exam.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = () => {
    if (!isSubmitting) submitExam();
  };

  return (
    <div style={modalStyle}>
      <h2>Review Your Answers</h2>
      <img
        src={require("../../assets/images/evt.png")}
        alt="Evaluatech-logo"
        style={{
          height: "12rem",
          top: "0",
          right: "0",
          display: "flex",
          position: "absolute",
        }}
      />

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Question No.</th>
            <th style={thStyle}>Question</th>
            <th style={thStyle}>Your Response</th>
          </tr>
        </thead>
        <tbody>
          {questions.map((question, index) => (
            <tr key={question.QuestionId}>
              <td style={tdStyle}>{index + 1}</td>
              <td style={tdStyle}>{question.Questions}</td>
              <td style={tdStyle}>
                {selectedAnswers[index]?.Options ?? <span style={{color: "red", fontWeight: "bold"}}>Not answered</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          marginTop: "20px",
          gap: "20px",
        }}
      >
        <CustomButton
          text={isSubmitting ? "Submitting..." : "Submit"}
          onClick={handleSubmit}
          disabled={isSubmitting}
        />
        <CustomButton text="Cancel" onClick={onClose} disabled={isSubmitting} />
      </div>
    </div>
  );
}

export default ReviewPage;
